<div class="information-clause personal-data-administrator" *ngIf="sectionVisible">
  <div class="information-clause__wrapper">
    <p>{{ 'PERSONAL_DATA_ADMINISTRATOR_SECTION.info' | translate }}</p>
    <p [innerHTML]="attachmentsTranslation.path | translate: true: attachmentsTranslation.params | safeHtml"></p>
  </div>
</div>
